// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
// @mui material components
import { Avatar, Tooltip, InputLabel } from "@mui/material";

import colors from "../../assets/theme/base/colors";
import MKTypography from "../MKTypography";
import MKBox from "../MKBox";
import { motion } from "framer-motion";
import MDBox from "../MDBox";
import constants from "../../common/constants";

const AppIconButton = (props) => {
  const {
    avatarIcon,
    avatarTag,
    avatarTooltip,
    avatarShortTag,
    avatarTagColor,
    avatarBgColor,
    avatarBorderWidth,
    avatarBorderColor,
    appHref,
    avatarBoxShadow,
    avatarMinDim,
    avatarMaxDim,
    avatarWidth,
    fontSize,
    onClick,
    isShowToolTip,
    isShowAppTags,
    isOpenNewTab,
  } = props;

  const handleNavigate = () => {



    if (onClick === undefined) {
      if (isOpenNewTab) {
        window.open(appHref, "_blank");
      } else {
        window.location.href = appHref;
      }
    } else onClick();
  };

  return (
    <MDBox width="100%" display="flex" p={1}>
      <motion.div
        whileHover={{
          scale: 1.15,
          transition: { duration: 0.05 },
        }}
        onClick={handleNavigate}
        whileTap={{ scale: 0.98 }}
      >
        <MKBox
          sx={({ breakpoints }) => ({
            [breakpoints.down("md")]: {
              py: 1,
            },
          })}
        >
          <Tooltip title={isShowToolTip ? avatarTooltip : ""}>
            <Avatar
              alt={avatarTag + " Icon"}
              src={avatarIcon}
              sx={{
                border: `0.25px solid`,
                backgroundColor: avatarBgColor,
                borderColor: avatarBorderColor,
                borderWidth: avatarBorderWidth,
                boxShadow: avatarBoxShadow,
                cursor: "pointer",
                width: avatarWidth,
                minWidth: avatarMinDim,
                height: avatarWidth,
                minHeight: avatarMinDim,
                maxWidth: avatarMaxDim,
                maxHeight: avatarMaxDim,
                margin: "auto",
                alignItems: "center",
                alignSelf: "center",
                display: "center",
                justifyItems: "center",
              }}
            />
          </Tooltip>
        </MKBox>

        {isShowAppTags && (
          <MDBox
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <InputLabel shrink={false}>
              <MKTypography
                mt={1.25}
                sx={{ fontSize: fontSize, textAlign: "center" }}
                style={{
                  fontFamily: "Barlow",
                  color: avatarTagColor,
                  fontWeight: "600",
                }}
              >
                {avatarShortTag || avatarTag}
              </MKTypography>
            </InputLabel>
          </MDBox>
        )}
      </motion.div>
    </MDBox>
  );
};

AppIconButton.propTypes = {
  avatarIcon: PropTypes.node.isRequired,
  avatarTag: PropTypes.node.isRequired,
  isShowToolTip: PropTypes.bool,
  isShowAppTags: PropTypes.bool,
};
AppIconButton.defaultProps = {
  avatarBoxShadow: 3,
  avatarTagColor: colors.white.focus,
  avatarBgColor: "",
  avatarBorderWidth: 0,
  avatarMinDim: "80px",
  avatarMaxDim: "80px",
  avatarWidth: "9vw",
  fontSize: "1.1rem",
  avatarTooltip: "",
  isShowToolTip: false,
  isShowAppTags: true,
  xs: 4,
  md: 3,
  lg: 2,
};
export default AppIconButton;
